import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useCaptureDepthMeasurement } from "../../../hooks/Capture";
import DepthMeasurementRecords from "../DepthMeasurement/DepthMeasurementRecords";

interface DepthMeasurementTabProps {
  captureId: string;
  handleError: (error: any) => void;
  canEdit: boolean;
}

const DepthMeasurementTab: React.FC<DepthMeasurementTabProps> = ({ captureId, handleError, canEdit }) => {
  const { depthMeasurementRecordsData, isPending, createDepthMeasurement, updateDepthMeasurement, deleteDepthMeasurement, refetch } = useCaptureDepthMeasurement(captureId);

  if (isPending && depthMeasurementRecordsData.length === 0) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <DepthMeasurementRecords
      captureId={Number(captureId)}
      depthMeasurementRecordsData={depthMeasurementRecordsData}
      canEdit={canEdit}
      onCreate={async (values) => {
        await createDepthMeasurement(values).catch(handleError);
      }}
      onUpdate={async (id, values) => {
        await updateDepthMeasurement({ recordId: id, values }).catch(handleError);
      }}
      onDelete={async (id) => {
        await deleteDepthMeasurement(id).catch(handleError);
      }}
      onRequestRefresh={refetch}
    />
  );
};

export default DepthMeasurementTab;
